import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TranslateService } from '../../../../../services/translate.service';
import { WksCentralService } from '../../../services/wks-central.service';
import { NautikoWSScannerService, NautikoWSScanner } from '../../../services/nautiko-ws-scanner.service';
import { WksGedDocumentService } from '../../../../job-wks/services/wks-ged-document.service';

import { RemoteFilesService } from '../../../../common/services/remote-files.service';

import { GedScannerModel } from '../../../models/wks-entity.model';

import { UserService } from '../../../../../services/user.service';
import { WksGedDocument } from '../../../../../job/job-wks/models/wks-works.model';

@Component({
    selector: 'mdi-ged-scanner',
    templateUrl: './ged-scanner.component.html',
    styleUrls: ['./ged-scanner.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class GedScannerComponent implements OnInit {

    gedScanners: GedScannerModel[] = [];
    scannerCur: GedScannerModel;
    scanning: boolean;
    saving: boolean;
    cancelling: boolean;
    confirmCancel: boolean;
    scansCount: number;

    scannerDevices: NautikoWSScanner[] = [];
    scannerDeviceCur: NautikoWSScanner;

    tenant: string;
    business: string;

    scans: {
        scanId: string;
        filename: string;
        blob: Blob;
        url: string;
    }[] = [];

    gedDocuments: WksGedDocument[] = [];

    scanError: string;

    constructor(
        private _userService: UserService,
        private _dialogRef: MatDialogRef<GedScannerComponent>,
        private _translateService: TranslateService,
        private _wksCentralService: WksCentralService,
        private _scannerService: NautikoWSScannerService,
        private _remoteFilesService: RemoteFilesService,
        private _gedDocumentService: WksGedDocumentService,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        this.scanning = false;
        this.saving = false;
        this.cancelling = false;
        this.confirmCancel = false;
        this.scansCount = 0;

        this.tenant =
            _data ? _data.tenant : undefined;

        this.business =
            _data ? _data.business : undefined;
    }

    ngOnInit(): void {
        this.gedScanners =
            this._wksCentralService.getGedScanners();

        const activeScanners =
            this.gedScanners.filter(
                scanner => scanner.active === true
            );

        if (activeScanners.length === 1) {
            this.scannerCur =
                activeScanners[0];

            this.loadScannerDevices();
        }
    }

    /**
     * Recherche des scanners physiques
     * accessibles par le scanner GED sélectionné.
     */
    loadScannerDevices(): void {
        this.scannerDevices = [];
        this.scannerDeviceCur = undefined;
        this.scanError = undefined;

        if (!this.scannerCur) {
            return;
        }

        console.log(
            'Recherche des scanners sur :',
            this.scannerCur.url
        );

        this._scannerService
            .getScanners(this.scannerCur)
            .subscribe(
                scanners => {
                    console.log(
                        'Scanners physiques détectés :',
                        scanners
                    );

                    this.scannerDevices =
                        scanners || [];

                    if (
                        this.scannerDevices.length === 1
                    ) {
                        this.scannerDeviceCur =
                            this.scannerDevices[0];

                        console.log(
                            'Scanner physique sélectionné :',
                            this.scannerDeviceCur
                        );
                    }
                },
                error => {
                    console.error(
                        'Erreur détection scanners :',
                        error
                    );

                    this.scanError =
                        'Impossible de détecter les scanners.';
                }
            );
    }

    /**
     * Demande l'annulation de la session.
     *
     * Les documents déjà sauvegardés sont
     * persistés immédiatement. Ils doivent donc
     * être supprimés de la GED si l'utilisateur
     * abandonne la session.
     */
    cancel(): void {
        if (
            this.scanning ||
            this.saving ||
            this.cancelling
        ) {
            return;
        }

        if (this.gedDocuments.length === 0) {
            this._dialogRef.close({
                action: 'cancelAction'
            });
            return;
        }

        this.confirmCancel = true;
    }

    /**
     * Confirme l'annulation de toute la session.
     */
    confirmCancelSession(): void {
        if (
            this.cancelling ||
            this.scanning ||
            this.saving
        ) {
            return;
        }

        this.confirmCancel = false;
        this.cancelling = true;
        this.scanError = undefined;

        this._gedDocumentService
            .cancelGedDocuments(this.gedDocuments)
            .subscribe(
                () => {

                    this.scans.forEach(scan => {
                        if (scan.url) {
                            URL.revokeObjectURL(
                                scan.url
                            );
                        }
                    });

                    this._dialogRef.close({
                        action: 'cancelAction'
                    });
                },
                error => {
                    console.error(
                        'Erreur annulation session GED :',
                        error
                    );

                    this.cancelling = false;

                    this.scanError =
                        'Impossible d’annuler la session de numérisation.';
                }
            );
    }

    /**
     * Annule la demande de confirmation
     * et revient à la session de numérisation.
     */
    cancelCancelConfirmation(): void {
        if (this.cancelling) {
            return;
        }

        this.confirmCancel = false;
    }

    /**
     * Lance une numérisation.
     *
     * Chaque document est immédiatement envoyé
     * à la GED après récupération du scan.
     */
    startScan(): void {
        if (
            !this.scannerCur ||
            !this.scannerDeviceCur
        ) {
            return;
        }

        if (
            this.scans.length >= 10 ||
            this.scanning ||
            this.saving ||
            this.cancelling ||
            this.confirmCancel
        ) {
            return;
        }

        this.scanning = true;
        this.saving = false;
        this.scanError = undefined;

        this._scannerService
            .scan(
                this.scannerCur,
                this.scannerDeviceCur.id
            )
            .subscribe(
                result => {

                    if (
                        !result ||
                        !result.scanId
                    ) {
                        this.scanError =
                            'Numérisation non retournée.';

                        this.scanning = false;
                        return;
                    }

                    this._scannerService
                        .getScan(
                            this.scannerCur,
                            result.scanId
                        )
                        .subscribe(
                            blob => {

                                this.scanning = false;
                                this.saving = true;
                                const now = new Date();

                                const date =
                                    now.getFullYear().toString() +
                                    String(now.getMonth() + 1).padStart(2, '0') +
                                    String(now.getDate()).padStart(2, '0');

                                const time =
                                    String(now.getHours()).padStart(2, '0') +
                                    String(now.getMinutes()).padStart(2, '0') +
                                    String(now.getSeconds()).padStart(2, '0') +
                                    String(Math.floor(now.getMilliseconds() / 10)).padStart(2, '0');

                                const gedFilename =
                                    'SCAN_' + date + '_' + time + '.png';

                                /*
                                 * Transformation du Blob
                                 * en File pour l'envoi GED.
                                 */
                                const file =
                                    new File(
                                        [blob],
                                        gedFilename,
                                        {
                                            type: blob.type
                                        }
                                    );

                                /*
                                 * Création du document GED.
                                 *
                                 * Le document est encore
                                 * sans référence métier.
                                 */
                                const document =
                                    new WksGedDocument();

                                document.stdEntity =
                                    this.tenant;

                                document.documentType =
                                    this.business;

                                document.documentName =
                                    gedFilename;

                                document.mimeType =
                                    blob.type;

                                document.documentSrc =
                                    'SCANNER';

                                document.processingStatus =
                                    'WAITING';
                                document.otherDatas =
                                    JSON.stringify({
                                        scanId: result.scanId
                                    });
                                /*
                                 * Sauvegarde immédiate du fichier
                                 * et du document GED.
                                 */
                                this._remoteFilesService
                                    .pushFileGed(
                                        file,
                                        document
                                    )
                                    .subscribe(
                                        savedDocument => {

                                            /*
                                            * La sauvegarde GED est confirmée.
                                            * Le fichier temporaire Python peut maintenant
                                            * être supprimé.
                                            */
                                            this._scannerService
                                                .deleteScan(
                                                    this.scannerCur,
                                                    result.scanId
                                                )
                                                .subscribe(
                                                    () => {

                                                        /*
                                                        * Le document n'est ajouté
                                                        * à la session qu'après confirmation
                                                        * de la sauvegarde GED.
                                                        */
                                                        this.gedDocuments.push(
                                                            savedDocument
                                                        );

                                                        /*
                                                        * Conservation du scan
                                                        * pour l'affichage dans la fenêtre.
                                                        */
                                                        const url =
                                                            URL.createObjectURL(
                                                                blob
                                                            );

                                                        this.scans.push({
                                                            scanId: result.scanId,
                                                            filename: savedDocument.documentName,
                                                            blob: blob,
                                                            url: url
                                                        });

                                                        this.scansCount =
                                                            this.scans.length;

                                                        this.saving = false;
                                                    },
                                                    error => {

                                                        console.error(
                                                            'Erreur suppression fichier temporaire :',
                                                            error
                                                        );

                                                        /*
                                                        * Le fichier GED est déjà sauvegardé.
                                                        * L'échec de suppression du fichier temporaire
                                                        * ne remet donc pas en cause le scan.
                                                        */
                                                        this.gedDocuments.push(
                                                            savedDocument
                                                        );

                                                        const url =
                                                            URL.createObjectURL(
                                                                blob
                                                            );

                                                        this.scans.push({
                                                            scanId:
                                                                result.scanId,
                                                            filename:
                                                                result.filename,
                                                            blob:
                                                                blob,
                                                            url:
                                                                url
                                                        });

                                                        this.scansCount =
                                                            this.scans.length;

                                                        this.saving = false;
                                                    }
                                                );
                                        },
                                        error => {

                                            console.error(
                                                'Erreur sauvegarde GED :',
                                                error
                                            );

                                            this.scanError =
                                                'Impossible de sauvegarder le document.';

                                            this.saving = false;
                                        }
                                    );
                            },
                            error => {

                                console.error(
                                    'Erreur récupération scan :',
                                    error
                                );

                                this.scanError =
                                    'Impossible de récupérer le document numérisé.';

                                this.scanning = false;
                            }
                        );
                },
                error => {

                    console.error(
                        'Erreur lancement scan :',
                        error
                    );

                    this.scanError =
                        'Impossible de lancer la numérisation.';

                    this.scanning = false;
                }
            );
    }

    /**
     * Termine la séquence de numérisation.
     *
     * Les documents restent en statut WAITING.
     * Le traitement métier sera effectué
     * ultérieurement lors du vidéo-codage.
     */
    validate(): void {
        if (
            this.scanning ||
            this.saving ||
            this.cancelling ||
            this.confirmCancel ||
            this.gedDocuments.length === 0
        ) {
            return;
        }

        this._dialogRef.close({
            action: 'okAction',
            gedDocuments: this.gedDocuments
        });
    }
}
